import { cssTransfromValueForAnchorPosition } from './cssTransfromValueForAnchorPosition';

export type OverlayYAnchorPosition = 'top' | 'center' | 'bottom';
export type OverlayXAnchorPosition = 'left' | 'center' | 'right';
export interface OverlayAnchorPosition {
  x: OverlayXAnchorPosition;
  y: OverlayYAnchorPosition;
}

export const pcaOverlayFactory = (
  map: google.maps.Map,
  container: HTMLElement,
  pane: keyof google.maps.MapPanes,
  position: google.maps.LatLng | google.maps.LatLngLiteral,
  minZoomLevelToDisplayOverlay?: number,
  anchorPosition: OverlayAnchorPosition = {
    x: 'center',
    y: 'center',
  },
) => {
  if (!map) return null;
  class PcaOverlay extends google.maps.OverlayView {
    container: HTMLElement;

    pane: keyof google.maps.MapPanes;

    position: google.maps.LatLng | google.maps.LatLngLiteral;

    zoomListener?: google.maps.MapsEventListener;

    overlayAnchorPosition: OverlayAnchorPosition;

    constructor(
      overlayContainer: HTMLElement,
      overlayPane: keyof google.maps.MapPanes,
      overlayPosition: google.maps.LatLng | google.maps.LatLngLiteral,
      overlayAnchorPosition: OverlayAnchorPosition,
    ) {
      super();
      this.container = overlayContainer;
      this.pane = overlayPane;
      this.position = overlayPosition;
      this.overlayAnchorPosition = overlayAnchorPosition;
    }

    onAdd(): void {
      this.getPanes()?.[this.pane]?.appendChild(this.container);

      const zoom = map.getZoom();
      if (zoom && minZoomLevelToDisplayOverlay) {
        this.container.style.visibility =
          zoom >= minZoomLevelToDisplayOverlay ? 'visible' : 'hidden';
      }

      this.zoomListener = google.maps.event.addListener(map, 'zoom_changed', () => this.onZoom());
    }

    draw(): void {
      const projection = this.getProjection();
      const point = projection.fromLatLngToDivPixel(this.position);
      if (!point) return;
      this.container.style.left = `${point.x}px`;
      this.container.style.top = `${point.y}px`;

      this.container.style.transform = cssTransfromValueForAnchorPosition(
        this.overlayAnchorPosition,
      );
    }

    onRemove(): void {
      if (this.container.parentNode !== null) {
        this.container.parentNode.removeChild(this.container);
      }
      if (this.zoomListener) {
        google.maps.event.removeListener(this.zoomListener);
      }
    }

    onZoom(): void {
      const zoom = map.getZoom();
      if (zoom && minZoomLevelToDisplayOverlay) {
        this.container.style.visibility =
          zoom >= minZoomLevelToDisplayOverlay ? 'visible' : 'hidden';
      }
    }
  }

  return new PcaOverlay(container, pane, position, anchorPosition);
};
